if (!customElements.get('molly-seat-controller')) {
  customElements.define('molly-seat-controller', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.seats = { left: false, right: false };
      this.states = [...this.querySelectorAll('[data-molly-state]')];
      this.badge = this.querySelector('[data-molly-status]');
      this.live = this.querySelector('[aria-live]');
      const controls = this.querySelector('.lmb-molly-controller__controls');
      if (!this.states.length || !controls) return;
      controls.hidden = false;
      this.onSeatClick = event => {
        const button = event.target.closest('button[data-seat], button[data-both]');
        if (!button || !this.contains(button)) return;
        if (button.dataset.seat) {
          this.seats[button.dataset.seat] = button.dataset.position === 'extended';
        } else {
          this.seats.left = button.dataset.both === 'extended';
          this.seats.right = this.seats.left;
        }
        this.render();
      };
      controls.addEventListener('click', this.onSeatClick);
      this.render();
    }

    render() {
      const key = this.seats.left && this.seats.right ? 'both' : this.seats.left ? 'left' : this.seats.right ? 'right' : 'closed';
      this.states.forEach(state => {
        const active = state.dataset.mollyState === key;
        state.toggleAttribute('data-active', active);
        state.setAttribute('aria-hidden', String(!active));
      });
      this.querySelectorAll('button[data-seat]').forEach(button => {
        button.setAttribute('aria-pressed', String(this.seats[button.dataset.seat] === (button.dataset.position === 'extended')));
      });
      const label = this.dataset[key + 'Label'];
      if (label) {
        this.badge.textContent = label;
        this.live.textContent = label;
      }
    }

    disconnectedCallback() {
      this.querySelector('.lmb-molly-controller__controls')?.removeEventListener('click', this.onSeatClick);
      this.started = false;
    }
  });
}
